import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import RadioGroup from './../RadioGroup';
import { withTranslation, Trans } from 'react-i18next';
import { cameraView03HullTreatmentImageOptions } from './views/CameraView03HullTreatment'

class X49HullTreatment extends Component {
    constructor(props) {
        super(props);
        this.handleHullTreatmentChange = this.handleHullTreatmentChange.bind(this);
    }


    handleHullTreatmentChange(newValue) {
        let configuration = this.props.configuration;
        configuration.HullTreatment = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = cameraView03HullTreatmentImageOptions;

        let image = <ConfiguratorImage boat="X4_9" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>
                    <h1><Trans defaults='Hull treatment' /></h1>

                    <p><Trans defaults='X49 Hull Treatment Text' /></p>

                    <RadioGroup label={this.props.t("Treatment options:")} options={this.props.hullTreatmentOptions} value={this.props.configuration.HullTreatment} onChange={this.handleHullTreatmentChange} />

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X49HullTreatment);


// WEBPACK FOOTER //
// ./src/X49/X49HullTreatment.js